import { render, staticRenderFns } from "./LuckyAward.vue?vue&type=template&id=223147ee&scoped=true&"
import script from "./LuckyAward.vue?vue&type=script&lang=js&"
export * from "./LuckyAward.vue?vue&type=script&lang=js&"
import style0 from "./LuckyAward.vue?vue&type=style&index=0&id=223147ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223147ee",
  null
  
)

export default component.exports